export default {
  setEngagementInformationTemplateTopic(state, payload) {
    state.engagementInformationTemplateTopic = payload;
  },
};
